import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Component } from "./DropDown.style";
import { DropDownProvider } from "./DropDownContext";
import { ThemeProvider } from "styled-components";
import { theme } from "../../theme";

interface Props { 
  className?: string,
  children?: React.ReactNode
  dropleft?: boolean,
  dropright?: boolean,
  dropup?: boolean,
  isOpen?: boolean,
  toogle?: () => {},
  tag?: string,
}


const DropDown = (props: Props ) => {
  const { className, tag, children, dropleft, dropright, dropup, ...attributes } = props;
  const dropdownClasses = classNames("dropdown", className);

  const dropdownComponent = (
    <ThemeProvider theme={theme}>
      <DropDownProvider>
        <Component
          className={dropdownClasses}
          role="dropdown"
          as={(tag as unknown) as undefined}
          dropleft={dropleft}
          dropright={dropright}
          dropup={dropup}
          {...attributes}
        >
          {children}
        </Component>
      </DropDownProvider>
    </ThemeProvider>
  );

  return dropdownComponent;
};

DropDown.defaultProps = {
  dropleft: false,
  dropright: false,
  dropup: false,
  tag: "span",
};

DropDown.propTypes = {
  className: PropTypes.string,
  dropleft: PropTypes.bool,
  dropright: PropTypes.bool,
  dropup: PropTypes.bool,
  isOpen: PropTypes.bool,
  toogle: PropTypes.func,
  tag: PropTypes.string,
};

export default DropDown;
export { DropDown as CDBDropDown };
